import { Box, BoxProps } from '@cdl/heartbeat-react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { squareToPixel } from '../../../plot/utils/graph.utils';
import * as beatsActions from '../../../beats/beats.actions';
import { togglePinnedBeat } from '../../thunks/toggle-pinned-beat.thunk';

const RADIUS = squareToPixel(2 / 8);

type Props = {
  point: { x: number; y: number; id: number };
  opacity: 1 | 0.3;
} & BoxProps;

export const LorenzGraphDatum: React.FC<Props> = ({
  point,
  stroke,
  opacity = 0.3,
}) => {
  const dispatch = useDispatch();

  const onSelectedCallback = useCallback(() => {
    dispatch(togglePinnedBeat(point.id));
  }, [dispatch, point]);

  const onHoverLeave = useCallback(() => {
    dispatch(beatsActions.toggleHoveredBeat({}));
  }, [dispatch]);

  const onHoverEnter = useCallback(() => {
    dispatch(beatsActions.toggleHoveredBeat({ id: point.id }));
  }, [dispatch, point]);

  return (
    <g
      key={point.id}
      transform={`translate(${point.x}, ${point.y})`}
      data-testid='scatter-point'
      cursor='pointer'
      onMouseDown={onSelectedCallback}
      onMouseEnter={onHoverEnter}
      onMouseLeave={onHoverLeave}
    >
      <Box
        as='circle'
        r={RADIUS / 2}
        strokeWidth={2}
        opacity={opacity}
        stroke={stroke}
        fill={stroke}
      />
    </g>
  );
};
